/* sucrase/dist/esm/parser/tokenizer/keywords.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    (function (ContextualKeyword) {
        const NONE = 0;
        ContextualKeyword[ContextualKeyword["NONE"] = NONE] = "NONE";
        const _abstract = NONE + 1;
        ContextualKeyword[ContextualKeyword["_abstract"] = _abstract] = "_abstract";
        const _accessor = _abstract + 1;
        ContextualKeyword[ContextualKeyword["_accessor"] = _accessor] = "_accessor";
        const _as = _accessor + 1;
        ContextualKeyword[ContextualKeyword["_as"] = _as] = "_as";
        const _assert = _as + 1;
        ContextualKeyword[ContextualKeyword["_assert"] = _assert] = "_assert";
        const _asserts = _assert + 1;
        ContextualKeyword[ContextualKeyword["_asserts"] = _asserts] = "_asserts";
        const _async = _asserts + 1;
        ContextualKeyword[ContextualKeyword["_async"] = _async] = "_async";
        const _await = _async + 1;
        ContextualKeyword[ContextualKeyword["_await"] = _await] = "_await";
        const _checks = _await + 1;
        ContextualKeyword[ContextualKeyword["_checks"] = _checks] = "_checks";
        const _constructor = _checks + 1;
        ContextualKeyword[ContextualKeyword["_constructor"] = _constructor] = "_constructor";
        const _declare = _constructor + 1;
        ContextualKeyword[ContextualKeyword["_declare"] = _declare] = "_declare";
        const _enum = _declare + 1;
        ContextualKeyword[ContextualKeyword["_enum"] = _enum] = "_enum";
        const _exports = _enum + 1;
        ContextualKeyword[ContextualKeyword["_exports"] = _exports] = "_exports";
        const _from = _exports + 1;
        ContextualKeyword[ContextualKeyword["_from"] = _from] = "_from";
        const _get = _from + 1;
        ContextualKeyword[ContextualKeyword["_get"] = _get] = "_get";
        const _global = _get + 1;
        ContextualKeyword[ContextualKeyword["_global"] = _global] = "_global";
        const _implements = _global + 1;
        ContextualKeyword[ContextualKeyword["_implements"] = _implements] = "_implements";
        const _infer = _implements + 1;
        ContextualKeyword[ContextualKeyword["_infer"] = _infer] = "_infer";
        const _interface = _infer + 1;
        ContextualKeyword[ContextualKeyword["_interface"] = _interface] = "_interface";
        const _is = _interface + 1;
        ContextualKeyword[ContextualKeyword["_is"] = _is] = "_is";
        const _keyof = _is + 1;
        ContextualKeyword[ContextualKeyword["_keyof"] = _keyof] = "_keyof";
        const _mixins = _keyof + 1;
        ContextualKeyword[ContextualKeyword["_mixins"] = _mixins] = "_mixins";
        const _module = _mixins + 1;
        ContextualKeyword[ContextualKeyword["_module"] = _module] = "_module";
        const _namespace = _module + 1;
        ContextualKeyword[ContextualKeyword["_namespace"] = _namespace] = "_namespace";
        const _of = _namespace + 1;
        ContextualKeyword[ContextualKeyword["_of"] = _of] = "_of";
        const _opaque = _of + 1;
        ContextualKeyword[ContextualKeyword["_opaque"] = _opaque] = "_opaque";
        const _out = _opaque + 1;
        ContextualKeyword[ContextualKeyword["_out"] = _out] = "_out";
        const _override = _out + 1;
        ContextualKeyword[ContextualKeyword["_override"] = _override] = "_override";
        const _private = _override + 1;
        ContextualKeyword[ContextualKeyword["_private"] = _private] = "_private";
        const _protected = _private + 1;
        ContextualKeyword[ContextualKeyword["_protected"] = _protected] = "_protected";
        const _proto = _protected + 1;
        ContextualKeyword[ContextualKeyword["_proto"] = _proto] = "_proto";
        const _public = _proto + 1;
        ContextualKeyword[ContextualKeyword["_public"] = _public] = "_public";
        const _readonly = _public + 1;
        ContextualKeyword[ContextualKeyword["_readonly"] = _readonly] = "_readonly";
        const _require = _readonly + 1;
        ContextualKeyword[ContextualKeyword["_require"] = _require] = "_require";
        const _satisfies = _require + 1;
        ContextualKeyword[ContextualKeyword["_satisfies"] = _satisfies] = "_satisfies";
        const _set = _satisfies + 1;
        ContextualKeyword[ContextualKeyword["_set"] = _set] = "_set";
        const _static = _set + 1;
        ContextualKeyword[ContextualKeyword["_static"] = _static] = "_static";
        const _symbol = _static + 1;
        ContextualKeyword[ContextualKeyword["_symbol"] = _symbol] = "_symbol";
        const _type = _symbol + 1;
        ContextualKeyword[ContextualKeyword["_type"] = _type] = "_type";
        const _unique = _type + 1;
        ContextualKeyword[ContextualKeyword["_unique"] = _unique] = "_unique";
        const _using = _unique + 1;
        ContextualKeyword[ContextualKeyword["_using"] = _using] = "_using";
    })(exports.ContextualKeyword || (exports.ContextualKeyword = {}));
}
